export const locales = ["es", "en", "it"];
export const defaultLocale = "es";
export const localeInfo = {
    es: { label: "ES", name: "Español", htmlLang: "es-AR", ogLocale: "es_AR" },
    en: { label: "EN", name: "British English", htmlLang: "en-GB", ogLocale: "en_GB" },
    it: { label: "IT", name: "Italiano", htmlLang: "it-IT", ogLocale: "it_IT" },
};
export function isLocale(value) {
    return locales.includes(value);
}
export const projects = [
    {
        title: "BlackPhone",
        category: "E-commerce",
        description: {
            es: "Catálogo y experiencia de compra para tecnología móvil.",
            en: "A mobile technology catalogue and shopping experience.",
            it: "Catalogo ed esperienza di acquisto per tecnologia mobile.",
        },
        image: "/assets/projects/project5.webp",
        href: "https://blackphone.com.ar/",
    },
    {
        title: "Dra. Benítez Alelí",
        category: "Legal",
        description: {
            es: "Presencia profesional clara, accesible y orientada a consultas.",
            en: "A clear, accessible professional presence focused on enquiries.",
            it: "Una presenza professionale chiara, accessibile e orientata ai contatti.",
        },
        image: "/assets/projects/project6.webp",
        href: "https://drabenitezaleli.corpresi.com/",
    },
    {
        title: "La Fortaleza",
        category: "Commerce",
        description: {
            es: "Plataforma comercial con catálogo y operación personalizada.",
            en: "A bespoke commercial platform with a product catalogue.",
            it: "Piattaforma commerciale su misura con catalogo prodotti.",
        },
        image: "/assets/projects/project4.webp",
        href: "https://lafortaleza.com.ar/",
    },
    {
        title: "Resi Máximo Felipe",
        category: "Portfolio",
        description: {
            es: "Portfolio personal de desarrollo, proyectos y experiencia.",
            en: "A personal portfolio for development work and experience.",
            it: "Portfolio personale dedicato a sviluppo, progetti ed esperienza.",
        },
        image: "/assets/projects/project7.webp",
        href: "https://resimaximo.corpresi.com/",
    },
    {
        title: "GAIR Instalaciones",
        category: "Industry",
        description: {
            es: "Identidad digital para servicios e instalaciones industriales.",
            en: "A digital identity for industrial services and installations.",
            it: "Identità digitale per servizi e installazioni industriali.",
        },
        image: "/assets/projects/project3.webp",
    },
    {
        title: "Desktop Management",
        category: "Application",
        description: {
            es: "Aplicación de escritorio adaptada a procesos operativos reales.",
            en: "A desktop application tailored to real operational workflows.",
            it: "Applicazione desktop adattata a flussi operativi reali.",
        },
        image: "/assets/projects/project2.webp",
    },
    {
        title: "DelSur Inmobiliaria",
        category: "Real estate",
        description: {
            es: "Portal inmobiliario con buscador, propiedades y gestión de consultas.",
            en: "A property portal with search, listings and enquiry management.",
            it: "Portale immobiliare con ricerca, annunci e gestione dei contatti.",
        },
        image: "/assets/projects/project1.webp",
        href: "https://inmobiliaria-delsur.com.ar/",
    },
];
export const associates = [
    {
        index: "01",
        title: {
            es: "Reparación y PCs",
            en: "Repairs & PCs",
            it: "Riparazioni e PC",
        },
        description: {
            es: "Reparación de celulares y servicio técnico especializado en armado y mantenimiento de computadoras.",
            en: "Mobile phone repairs and specialised technical service for building and maintaining computers.",
            it: "Riparazione di telefoni e assistenza tecnica specializzata per assemblaggio e manutenzione di computer.",
        },
        accent: "hephaestus",
    },
    {
        index: "02",
        title: {
            es: "Asesoría legal",
            en: "Legal advice",
            it: "Consulenza legale",
        },
        description: {
            es: "Consultas en Derecho Laboral y Sucesiones, con o sin testamento, dentro de Buenos Aires, Argentina.",
            en: "Employment and inheritance law advice, with or without a will, in Buenos Aires, Argentina.",
            it: "Consulenza in diritto del lavoro e successioni, con o senza testamento, a Buenos Aires, Argentina.",
        },
        accent: "athena",
    },
    {
        index: "03",
        title: {
            es: "Diseño UX/UI",
            en: "UX/UI design",
            it: "Design UX/UI",
        },
        description: {
            es: "Interfaces intuitivas y atractivas que mejoran la experiencia del usuario y la conversión de tu producto digital.",
            en: "Intuitive, attractive interfaces that improve user experience and boost your digital product’s conversion.",
            it: "Interfacce intuitive e accattivanti che migliorano l’esperienza utente e la conversione del tuo prodotto digitale.",
        },
        accent: "apollo",
    },
    {
        index: "04",
        title: {
            es: "Edición de video",
            en: "Video editing",
            it: "Video editing",
        },
        description: {
            es: "Transformamos tus videos en contenido profesional, atractivo y optimizado para redes sociales o uso empresarial.",
            en: "We transform your videos into professional, engaging content optimised for social media or business use.",
            it: "Trasformiamo i tuoi video in contenuti professionali, coinvolgenti e ottimizzati per i social o l’uso aziendale.",
        },
        accent: "hermes",
    },
];
export const siteCopy = {
    es: {
        metadata: {
            title: "Desarrollo web a medida en Argentina | Resi Corporation",
            description: "Diseñamos y desarrollamos sitios web, tiendas y plataformas digitales rápidas, memorables y optimizadas para convertir visitas en clientes.",
        },
        nav: {
            home: "Inicio",
            services: "Servicios",
            projects: "Proyectos",
            process: "Proceso",
            associates: "Asociados",
            blog: "Blog",
            contact: "Contacto",
            menu: "Abrir menú",
        },
        hero: {
            eyebrow: "ESTUDIO DIGITAL · BUENOS AIRES",
            title: "Construimos experiencias digitales dignas de los dioses.",
            description: "Diseño, código y estrategia para convertir ideas ambiciosas en productos digitales rápidos, memorables y medibles.",
            primary: "Elevar mi proyecto",
            secondary: "Explorar trabajos",
            stats: ["+12 proyectos", "100% a medida", "ES / EN / IT"],
            code: "const idea = solve(); ship(idea);",
            orbit: ["Estrategia", "Diseño", "Código", "Lanzamiento"],
        },
        intro: {
            kicker: "01 · EL PANTEÓN DIGITAL",
            title: "Mucho más que una web bonita.",
            body: "Creamos herramientas que presentan tu marca, explican tu valor y facilitan que la persona correcta dé el siguiente paso.",
        },
        services: {
            kicker: "SERVICIOS",
            title: "Tres pilares. Un sistema digital completo.",
            items: [
                {
                    index: "I",
                    title: "Desarrollo web a medida",
                    description: "Sitios corporativos, portfolios, tiendas y plataformas construidas alrededor de tu negocio, sin plantillas que limiten la identidad.",
                    detail: "Diseño · Frontend · Backend · Integraciones",
                },
                {
                    index: "II",
                    title: "Productos y aplicaciones",
                    description: "Paneles, sistemas internos y experiencias digitales pensadas para automatizar procesos y acompañar el crecimiento.",
                    detail: "Dashboards · APIs · E-commerce · Automatización",
                },
                {
                    index: "III",
                    title: "Evolución y soporte",
                    description: "Alojamiento, mantenimiento, mejoras continuas y medición para que el producto permanezca rápido, seguro y vigente.",
                    detail: "Hosting · Analítica · SEO · Mantenimiento",
                },
            ],
        },
        arsenal: {
            kicker: "ARSENAL TÉCNICO",
            title: "Elegimos tecnología por lo que resuelve.",
            body: "No vendemos nombres de frameworks: seleccionamos una arquitectura mantenible, rápida y proporcional a cada proyecto.",
            groups: [
                { title: "Experiencia", values: ["React", "Vue", "Nuxt", "Next", "Astro"] },
                { title: "Sistemas", values: ["NestJS", "Node", "Laravel", "PHP", "Python"] },
                { title: "Datos", values: ["SQLite", "PostgreSQL", "MySQL", "APIs REST"] },
            ],
        },
        process: {
            kicker: "02 · LA FORJA",
            title: "De una idea dispersa a un producto listo para crecer.",
            description: "Cada etapa tiene un objetivo, una entrega visible y decisiones que podés entender.",
            steps: [
                { number: "01", title: "Descubrimiento", body: "Objetivos, audiencia, competencia y alcance real." },
                { number: "02", title: "Arquitectura", body: "Contenido, recorridos, tecnología y prototipo." },
                { number: "03", title: "Construcción", body: "Desarrollo iterativo, accesibilidad y medición." },
                { number: "04", title: "Lanzamiento", body: "Pruebas, publicación, seguimiento y evolución." },
            ],
        },
        projects: {
            kicker: "03 · PROYECTOS",
            title: "Algunos de nuestros proyectos.",
            description: "Una selección de sitios y aplicaciones creados para negocios, profesionales y equipos reales. Seguimos sumando nuevas experiencias.",
            view: "Visitar proyecto",
            details: "Ver caso",
            unavailable: "Caso privado",
        },
        testimonials: {
            kicker: "VOCES DEL ÁGORA",
            title: "Lo que valoraron nuestros clientes.",
            items: [
                "Conseguí exactamente lo que buscaba con Resi Corporation. Me desarrollaron un sitio web moderno y animado, tal como lo había solicitado.",
                "El equipo de Resi Corporation hizo un excelente trabajo con nuestra página web, y los recomendamos a otras empresas.",
                "Gracias a Resi Corporation, pudimos modernizar el diseño de nuestra página web. Ahora tiene un aspecto mucho más profesional y moderno que el anterior.",
                "Gracias a la ayuda de Resi Corporation, pude obtener mi página web personal, con un diseño minimalista, moderno y sin uso de plantillas.",
            ],
            role: "Cliente · Desarrollo web",
        },
        contact: {
            kicker: "04 · EL ORÁCULO",
            title: "Contanos qué querés construir.",
            description: "Respondemos con preguntas concretas, una orientación inicial y un presupuesto sin compromiso.",
            name: "Nombre completo",
            email: "Email",
            phone: "Teléfono",
            service: "Tipo de proyecto",
            message: "¿Qué necesitás resolver?",
            consent: "Acepto que Resi Corporation utilice estos datos para responder mi consulta.",
            submit: "Enviar consulta",
            sending: "Enviando…",
            success: "Recibimos tu consulta. Muy pronto nos pondremos en contacto.",
            options: ["Sitio corporativo", "Tienda online", "Aplicación o plataforma", "Mantenimiento", "Otro"],
            direct: "Contacto directo",
            social: "Redes sociales",
        },
        blog: {
            kicker: "JOURNAL",
            title: "Ideas para construir una presencia digital más fuerte.",
            description: "Guías directas sobre desarrollo, posicionamiento, rendimiento y decisiones digitales.",
            read: "Leer artículo",
            minutes: "min de lectura",
        },
        associated: {
            kicker: "RED DE ASOCIADOS",
            title: "Especialistas para necesidades que rodean tu proyecto.",
            description: "Servicios independientes ofrecidos por profesionales asociados a Resi Corporation.",
            request: "Consultar servicio",
            explore: "Ver servicios asociados",
        },
        footer: {
            phrase: "Ideas ambiciosas, convertidas en experiencias digitales.",
            rights: "Todos los derechos reservados.",
            eyebrow: "ESTUDIO DIGITAL · BUENOS AIRES",
            navigation: "Explorar",
            contact: "Contacto directo",
            social: "Seguinos",
            availability: "Proyectos en Argentina y el mundo.",
        },
    },
    en: {
        metadata: {
            title: "Bespoke web development | Resi Corporation",
            description: "We design and build fast, memorable websites, shops and digital platforms that turn visits into meaningful enquiries.",
        },
        nav: {
            home: "Home",
            services: "Services",
            projects: "Work",
            process: "Process",
            associates: "Partners",
            blog: "Journal",
            contact: "Contact",
            menu: "Open menu",
        },
        hero: {
            eyebrow: "DIGITAL STUDIO · BUENOS AIRES",
            title: "We build digital experiences worthy of the gods.",
            description: "Design, code and strategy turn ambitious ideas into fast, memorable and measurable digital products.",
            primary: "Elevate my project",
            secondary: "Explore our work",
            stats: ["12+ projects", "Fully bespoke", "ES / EN / IT"],
            code: "const idea = solve(); ship(idea);",
            orbit: ["Strategy", "Design", "Code", "Launch"],
        },
        intro: {
            kicker: "01 · THE DIGITAL PANTHEON",
            title: "Far more than a beautiful website.",
            body: "We create tools that present your brand, explain its value and help the right person take the next step.",
        },
        services: {
            kicker: "SERVICES",
            title: "Three pillars. One complete digital system.",
            items: [
                {
                    index: "I",
                    title: "Bespoke web development",
                    description: "Corporate sites, portfolios, shops and platforms built around your business, without templates restricting the identity.",
                    detail: "Design · Frontend · Backend · Integrations",
                },
                {
                    index: "II",
                    title: "Products and applications",
                    description: "Dashboards, internal systems and digital experiences designed to automate operations and support growth.",
                    detail: "Dashboards · APIs · E-commerce · Automation",
                },
                {
                    index: "III",
                    title: "Evolution and support",
                    description: "Hosting, maintenance, continuous improvement and measurement keep the product quick, secure and relevant.",
                    detail: "Hosting · Analytics · SEO · Maintenance",
                },
            ],
        },
        arsenal: {
            kicker: "TECHNICAL ARSENAL",
            title: "We choose technology for what it solves.",
            body: "We do not sell framework names. We select a maintainable, fast architecture proportionate to each project.",
            groups: [
                { title: "Experience", values: ["React", "Vue", "Nuxt", "Next", "Astro"] },
                { title: "Systems", values: ["NestJS", "Node", "Laravel", "PHP", "Python"] },
                { title: "Data", values: ["SQLite", "PostgreSQL", "MySQL", "REST APIs"] },
            ],
        },
        process: {
            kicker: "02 · THE FORGE",
            title: "From a scattered idea to a product ready to grow.",
            description: "Each stage has an objective, a visible deliverable and decisions you can understand.",
            steps: [
                { number: "01", title: "Discovery", body: "Objectives, audience, competitors and realistic scope." },
                { number: "02", title: "Architecture", body: "Content, journeys, technology and prototype." },
                { number: "03", title: "Build", body: "Iterative development, accessibility and measurement." },
                { number: "04", title: "Launch", body: "Testing, publishing, monitoring and evolution." },
            ],
        },
        projects: {
            kicker: "03 · PROJECTS",
            title: "Some of our projects.",
            description: "A selection of sites and applications made for real businesses, professionals and teams, with new experiences continually joining the collection.",
            view: "Visit project",
            details: "View case",
            unavailable: "Private case",
        },
        testimonials: {
            kicker: "VOICES FROM THE AGORA",
            title: "What our clients valued.",
            items: [
                "I obtained exactly what I was looking for with Resi Corporation. They developed a modern and animated website, just as I had requested.",
                "The team at Resi Corporation did an excellent job with our website, and we highly recommend them to other businesses.",
                "Thanks to Resi Corporation, we were able to modernise the design of our website. It now has a much more refined and professional look than before.",
                "With the help of Resi Corporation, I was able to obtain my personal website—minimalist, modern, and built entirely without templates.",
            ],
            role: "Client · Web development",
        },
        contact: {
            kicker: "04 · THE ORACLE",
            title: "Tell us what you would like to build.",
            description: "We reply with focused questions, initial guidance and a no-obligation estimate.",
            name: "Full name",
            email: "Email",
            phone: "Phone",
            service: "Project type",
            message: "What do you need to solve?",
            consent: "I agree that Resi Corporation may use these details to reply to my enquiry.",
            submit: "Send enquiry",
            sending: "Sending…",
            success: "We have received your enquiry and will be in touch shortly.",
            options: ["Corporate site", "Online shop", "Application or platform", "Maintenance", "Other"],
            direct: "Direct contact",
            social: "Social media",
        },
        blog: {
            kicker: "JOURNAL",
            title: "Ideas for building a stronger digital presence.",
            description: "Straightforward guides to development, search visibility, performance and digital decisions.",
            read: "Read article",
            minutes: "min read",
        },
        associated: {
            kicker: "PARTNER NETWORK",
            title: "Specialists for the needs surrounding your project.",
            description: "Independent services delivered by professionals associated with Resi Corporation.",
            request: "Enquire about this service",
            explore: "View partner services",
        },
        footer: {
            phrase: "Ambitious ideas, turned into digital experiences.",
            rights: "All rights reserved.",
            eyebrow: "DIGITAL STUDIO · BUENOS AIRES",
            navigation: "Explore",
            contact: "Direct contact",
            social: "Follow us",
            availability: "Projects in Argentina and worldwide.",
        },
    },
    it: {
        metadata: {
            title: "Sviluppo web su misura | Resi Corporation",
            description: "Progettiamo e sviluppiamo siti, e-commerce e piattaforme digitali veloci e memorabili, pensati per generare contatti.",
        },
        nav: {
            home: "Home",
            services: "Servizi",
            projects: "Progetti",
            process: "Processo",
            associates: "Partner",
            blog: "Journal",
            contact: "Contatti",
            menu: "Apri menu",
        },
        hero: {
            eyebrow: "STUDIO DIGITALE · BUENOS AIRES",
            title: "Costruiamo esperienze digitali degne degli dei.",
            description: "Design, codice e strategia trasformano idee ambiziose in prodotti digitali veloci, memorabili e misurabili.",
            primary: "Elevare il mio progetto",
            secondary: "Esplora i lavori",
            stats: ["Oltre 12 progetti", "100% su misura", "ES / EN / IT"],
            code: "const idea = solve(); ship(idea);",
            orbit: ["Strategia", "Design", "Codice", "Lancio"],
        },
        intro: {
            kicker: "01 · IL PANTHEON DIGITALE",
            title: "Molto più di un bel sito.",
            body: "Creiamo strumenti che presentano il brand, ne spiegano il valore e aiutano la persona giusta a compiere il passo successivo.",
        },
        services: {
            kicker: "SERVIZI",
            title: "Tre pilastri. Un sistema digitale completo.",
            items: [
                {
                    index: "I",
                    title: "Sviluppo web su misura",
                    description: "Siti aziendali, portfolio, e-commerce e piattaforme costruiti intorno all’attività, senza template che limitano l’identità.",
                    detail: "Design · Frontend · Backend · Integrazioni",
                },
                {
                    index: "II",
                    title: "Prodotti e applicazioni",
                    description: "Dashboard, sistemi interni ed esperienze digitali pensate per automatizzare i processi e sostenere la crescita.",
                    detail: "Dashboard · API · E-commerce · Automazione",
                },
                {
                    index: "III",
                    title: "Evoluzione e supporto",
                    description: "Hosting, manutenzione, miglioramenti continui e misurazione mantengono il prodotto veloce, sicuro e attuale.",
                    detail: "Hosting · Analytics · SEO · Manutenzione",
                },
            ],
        },
        arsenal: {
            kicker: "ARSENALE TECNICO",
            title: "Scegliamo la tecnologia per ciò che risolve.",
            body: "Non vendiamo nomi di framework: selezioniamo un’architettura veloce, mantenibile e proporzionata a ogni progetto.",
            groups: [
                { title: "Esperienza", values: ["React", "Vue", "Nuxt", "Next", "Astro"] },
                { title: "Sistemi", values: ["NestJS", "Node", "Laravel", "PHP", "Python"] },
                { title: "Dati", values: ["SQLite", "PostgreSQL", "MySQL", "API REST"] },
            ],
        },
        process: {
            kicker: "02 · LA FUCINA",
            title: "Da un’idea dispersa a un prodotto pronto a crescere.",
            description: "Ogni fase ha un obiettivo, una consegna visibile e decisioni facili da comprendere.",
            steps: [
                { number: "01", title: "Scoperta", body: "Obiettivi, pubblico, concorrenza e perimetro realistico." },
                { number: "02", title: "Architettura", body: "Contenuti, percorsi, tecnologia e prototipo." },
                { number: "03", title: "Costruzione", body: "Sviluppo iterativo, accessibilità e misurazione." },
                { number: "04", title: "Lancio", body: "Test, pubblicazione, monitoraggio ed evoluzione." },
            ],
        },
        projects: {
            kicker: "03 · PROGETTI",
            title: "Alcuni dei nostri progetti.",
            description: "Una selezione di siti e applicazioni realizzati per aziende, professionisti e team, con nuove esperienze che continuano ad aggiungersi.",
            view: "Visita il progetto",
            details: "Vedi il caso",
            unavailable: "Caso privato",
        },
        testimonials: {
            kicker: "VOCI DELL’AGORÀ",
            title: "Ciò che i nostri clienti hanno apprezzato.",
            items: [
                "Ho ottenuto esattamente ciò che cercavo con Resi Corporation: un sito moderno e animato, proprio come lo avevo richiesto.",
                "Il team di Resi Corporation ha svolto un lavoro eccellente sul nostro sito e lo consigliamo ad altre aziende.",
                "Grazie a Resi Corporation abbiamo modernizzato il design del sito, che ora comunica un’immagine molto più curata e professionale.",
                "Con l’aiuto di Resi Corporation ho ottenuto il mio sito personale: minimalista, moderno e sviluppato interamente senza template.",
            ],
            role: "Cliente · Sviluppo web",
        },
        contact: {
            kicker: "04 · L’ORACOLO",
            title: "Raccontaci cosa vuoi costruire.",
            description: "Rispondiamo con domande concrete, un primo orientamento e un preventivo senza impegno.",
            name: "Nome e cognome",
            email: "Email",
            phone: "Telefono",
            service: "Tipo di progetto",
            message: "Che cosa devi risolvere?",
            consent: "Accetto che Resi Corporation utilizzi questi dati per rispondere alla richiesta.",
            submit: "Invia richiesta",
            sending: "Invio…",
            success: "Abbiamo ricevuto la tua richiesta e ti contatteremo al più presto.",
            options: ["Sito aziendale", "Negozio online", "Applicazione o piattaforma", "Manutenzione", "Altro"],
            direct: "Contatto diretto",
            social: "Social network",
        },
        blog: {
            kicker: "JOURNAL",
            title: "Idee per costruire una presenza digitale più forte.",
            description: "Guide dirette su sviluppo, visibilità, prestazioni e decisioni digitali.",
            read: "Leggi l’articolo",
            minutes: "min di lettura",
        },
        associated: {
            kicker: "RETE DI PARTNER",
            title: "Specialisti per le esigenze che circondano il progetto.",
            description: "Servizi indipendenti offerti da professionisti associati a Resi Corporation.",
            request: "Richiedi informazioni",
            explore: "Scopri i servizi associati",
        },
        footer: {
            phrase: "Idee ambiziose trasformate in esperienze digitali.",
            rights: "Tutti i diritti riservati.",
            eyebrow: "STUDIO DIGITALE · BUENOS AIRES",
            navigation: "Esplora",
            contact: "Contatto diretto",
            social: "Seguici",
            availability: "Progetti in Argentina e nel mondo.",
        },
    },
};
